/**
 * Tamanho de todo ícone exibido na navbar (menu mobile, conta, idioma, usuário) —
 * paridade com o `font-size: 24px` do `i` em `.navbar-nav > li` do legado.
 */
export const NAVBAR_ICON_SIZE = 24;
